import { z } from "zod/v4";
import { userRoleSchema } from "./auth";

// createUserSchema is the body for POST /admin/users — provisioning a Firebase
// login with a system role (e.g. an admin/analyst account for the BIS portal).
export const createUserSchema = z.object({
	email: z.string().email("Enter a valid email"),
	password: z.string().min(8, "At least 8 characters"),
	role: userRoleSchema,
	display_name: z.string().optional(),
});

// createdUserSchema is the response: the provisioned account's identity.
export const createdUserSchema = z.object({
	firebase_uid: z.string(),
	email: z.string(),
	role: userRoleSchema,
	display_name: z.string(),
});

export type CreateUser = z.infer<typeof createUserSchema>;
export type CreatedUser = z.infer<typeof createdUserSchema>;
